import { createSlice } from "@reduxjs/toolkit";
import { decodeToken } from "../utils/auth";

const authSlice = createSlice({
  name: "authSlice",
  initialState: {
    accessToken: "",
    userStatus: "",
  },
  reducers: {
    setAccessToken(state, action) {
      state.accessToken = action.payload;
      authSlice.caseReducers.setUserStatus(state, action);
    },
    setUserStatus(state, action) {
      const decodedToken = decodeToken(action.payload);
      state.userStatus = decodedToken?.userStatus || "";
    },
  },
});

export const sliceActions = authSlice.actions;

export default authSlice.reducer;
